import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=0c625b76&scoped=true&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"
import style0 from "./Tags.vue?vue&type=style&index=0&id=0c625b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c625b76",
  null
  
)

export default component.exports